import { useRef } from 'react'
import { TinyMCE } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useRecoilState, useRecoilValue } from 'recoil'
import { caseAtom, editCaseFieldSelector } from 'atoms'
import { TINYMCE_CASE_FIELD_SCHEMA } from 'components/global/TinyMCE/tinyMCESchema'

export const CaseTextAreaInput = ({ label, name, margin }) => {
  const _case = useRecoilValue(caseAtom)
  const [textareaValue, setTextareaValue] = useRecoilState(
    editCaseFieldSelector({ name: name, path: 'value' }),
  )
  const editorRef = useRef(null)

  const handleBlur = () => {
    if (editorRef.current) {
      let content = editorRef.current.getContent()
      if (!content) content = '<p></p>'
      setTextareaValue(content)
    }
  }

  return (
    <Flex column full margin={margin || '0'}>
      <Flex column align="flex-start">
        <Text as="h3" transform="capitalize">
          {label}
        </Text>
        <Flex
          border="1px solid"
          borderColor="gray4"
          height="500px"
          margin="0 0 25px 0"
          overflow="auto"
          padding="7px"
          onBlur={handleBlur}
          background="lockedWhite"
          id={`${name}-textarea`}
          width="100%"
        >
          <TinyMCE
            setRef={(ref) => (editorRef.current = ref)}
            value={textareaValue}
            caseDetails={_case}
            init={{
              toolbar: false,
              ...TINYMCE_CASE_FIELD_SCHEMA,
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CaseTextAreaInput
